import { Component, OnInit, inject } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { AmplifyModelService } from '../../services/amplify-model-service.service';

@Component({
  selector: 'app-dashboard-home',
  templateUrl: './dashboard-home.component.html',
  styleUrl: './dashboard-home.component.css',
  imports: [
    MatCardModule,
    MatIconModule,
    MatButtonModule
  ]
})
export class DashboardHomeComponent implements OnInit {
  
  private ams = inject(AmplifyModelService);

  constructor(private router: Router) {}

  async ngOnInit() {
    // Check user groups and redirect accordingly
    try {
      const groups = await this.ams.getUserGroups();
      
      if (groups.includes('SALES_REPS')) {
        console.log('🏠 Sales Rep detected - Redirecting to My Dashboard');
        this.router.navigate(['/dashboard/sales/my-dashboard']);
        return;
      }
      
      if (groups.includes('Technicians')) {
        console.log('🔧 Technician detected - Redirecting to Daily Schedule');
        this.router.navigate(['/dashboard/employee/schedule']);
        return;
      }
    } catch (error) {
      console.error('❌ Error checking user groups for dashboard redirect:', error);
      // Continue to show default dashboard if error occurs
    }
  }

  navigateTo(route: string) {
    this.router.navigate([route]);
  }
}